import { render, staticRenderFns } from "./KitDetails.vue?vue&type=template&id=00b45756"
import script from "./KitDetails.vue?vue&type=script&lang=ts"
export * from "./KitDetails.vue?vue&type=script&lang=ts"
import style0 from "./KitDetails.vue?vue&type=style&index=0&id=00b45756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports